import React from "react";
import { Navigate } from "react-router-dom";

const LandingPageComponent = () => {
  return <Navigate to="/dashboard" replace />;
};

export default LandingPageComponent;
